Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    COLORS = _STYLES$useStyles.COLORS,
    fontSemiBold = _STYLES$useStyles.fontSemiBold,
    bp = _STYLES$useStyles.bp,
    spacing = _STYLES$useStyles.spacing;
  var _containerHeight = _reactNative.PixelRatio.getFontScale() * _styles.baseSize * 2.25;
  var _spacer = _reactNative.PixelRatio.getFontScale() * _styles.baseSize * 0.25;
  var _triangleSize = _reactNative.PixelRatio.getFontScale() * _styles.baseSize * 1.5;
  var buttonHeight = _containerHeight - _spacer * 2;
  var container = {
    width: '100%',
    zIndex: 1
  };
  var roundedNavigation = {
    flexWrap: 'wrap',
    flexDirection: 'row',
    backgroundColor: COLORS.whisper,
    height: _containerHeight,
    borderRadius: _containerHeight,
    overflow: 'hidden',
    padding: _spacer,
    alignSelf: 'center',
    position: 'relative'
  };
  if (bp.is([bp.mobile_xs, bp.mobile_s])) {
    roundedNavigation.width = '100%';
  }
  var roundedNavigation_withmore = {
    paddingRight: _containerHeight
  };
  var buttonStyleContainer = {
    flexShrink: 1
  };
  if (bp.is([bp.mobile_xs, bp.mobile_s])) {
    buttonStyleContainer.flexGrow = 1;
  }
  var buttonStyleContainer_moreButton = {
    flexGrow: 0,
    position: 'absolute',
    top: _spacer,
    right: _spacer,
    width: buttonHeight,
    height: buttonHeight,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  };
  var buttonStyleContainer_marginLeft = {
    marginLeft: _spacer
  };
  var buttonStyleContainer_marginTop = {
    marginTop: _spacer
  };
  var buttonStyle = {
    textDecorationLine: 'none',
    textAlign: 'center',
    borderRadius: buttonHeight / 2,
    justifyContent: 'center',
    alignItems: 'center',
    height: buttonHeight,
    paddingLeft: spacing.normal,
    paddingRight: spacing.normal,
    display: 'flex',
    flexDirection: 'row',
    overflow: 'hidden'
  };
  var buttonStyle_moreButton = {
    width: buttonHeight,
    paddingLeft: 0,
    paddingRight: 0
  };
  var buttonStyle_moreMenu = {
    borderRadius: (0, _styles.getREM)(1),
    justifyContent: 'flex-start',
    textAlign: 'left'
  };
  var buttonStyle_pointerOver = {
    backgroundColor: COLORS.snuff
  };
  var buttonStyle_active = Object.assign({
    backgroundColor: COLORS.mischka
  }, _reactNative.Platform.select({
    web: {
      cursor: 'default'
    }
  }));
  var buttonText = Object.assign({}, fontSemiBold, {
    color: COLORS.aubergine,
    fontSize: _styles.STYLES.fontSize.xs,
    lineHeight: buttonHeight
  });
  if (bp.is([bp.tablet, bp.desktop])) {
    buttonText.fontSize = _styles.STYLES.fontSize.s;
  }
  var modalPressable = Object.assign({
    flex: 1
  }, _reactNative.Platform.select({
    web: {
      cursor: 'default'
    }
  }));
  var roundedNavigationDropdownContainer = {
    position: 'absolute',
    zIndex: 1,
    top: 0,
    alignItems: 'flex-end',
    width: '100%'
  };
  var roundedNavigationDropdown = {
    marginTop: _triangleSize / 2,
    marginRight: (0, _styles.getREM)(1),
    minWidth: (0, _styles.getREM)(11),
    backgroundColor: COLORS.whisper,
    flexDirection: 'column',
    borderRadius: (0, _styles.getREM)(1),
    padding: _spacer,
    transform: [{
      translateX: buttonHeight / 4
    }]
  };
  if (bp.is([bp.mobile_xs, bp.mobile_s])) {
    roundedNavigationDropdown.minWidth = 0;
    roundedNavigationDropdown.width = '100%';
  }
  var roundedNavigationDropdownArrow = {
    position: 'absolute',
    zIndex: 0,
    top: -1 * (_triangleSize / 2),
    right: (0, _styles.getREM)(0.75),
    width: _triangleSize,
    height: _triangleSize / 2
  };
  var iconContainer = {
    height: buttonHeight,
    width: buttonHeight
  };
  var icon = Object.assign({
    width: (0, _styles.getREM)(1.25),
    height: (0, _styles.getREM)(1.25)
  }, _reactNative.Platform.select({
    ios: {
      transform: [{
        translateY: (0, _styles.getREM)(0.1)
      }]
    },
    android: {
      transform: [{
        translateY: (0, _styles.getREM)(-0.1)
      }]
    }
  }));
  var styles = _reactNative.StyleSheet.create({
    container: container,
    roundedNavigation: roundedNavigation,
    roundedNavigation_withmore: roundedNavigation_withmore,
    buttonStyle: buttonStyle,
    buttonStyle_moreButton: buttonStyle_moreButton,
    buttonStyle_moreMenu: buttonStyle_moreMenu,
    buttonStyle_pointerOver: buttonStyle_pointerOver,
    buttonStyle_active: buttonStyle_active,
    buttonText: buttonText,
    buttonStyleContainer: buttonStyleContainer,
    buttonStyleContainer_moreButton: buttonStyleContainer_moreButton,
    buttonStyleContainer_marginLeft: buttonStyleContainer_marginLeft,
    buttonStyleContainer_marginTop: buttonStyleContainer_marginTop,
    modalPressable: modalPressable,
    roundedNavigationDropdownContainer: roundedNavigationDropdownContainer,
    roundedNavigationDropdown: roundedNavigationDropdown,
    roundedNavigationDropdownArrow: roundedNavigationDropdownArrow,
    iconContainer: iconContainer,
    icon: icon
  });
  return {
    styles: styles,
    buttonHeight: buttonHeight
  };
};